export default {
  googleFontFamily: [
    "Advent Pro",
    "Albert Sans",
    "Alumni Sans",
    "Anybody",
    "Archivo",
    "Asap",
    "Azeret Mono",
    "Barlow",
    "Barlow Condensed",
    "Barlow Semi Condensed",
    "Be Vietnam Pro",
    "Bitter",
    "Chivo",
    "Chivo Mono",
    "Epilogue",
    "Exo",
    "Exo 2",
    "Fira Sans",
    "Fira Sans Condensed",
    "Fira Sans Extra Condensed",
    "Fraunces",
    "Gantari",
    "Genos",
    "Georama",
    "Grandstander",
    "Grenze",
    "Hanken Grotesk",
    "Inter Tight",
    "Jost",
    "Kanit",
    "Labrada",
    "Libre Franklin",
    "Montserrat",
    "Montserrat Alternates",
    "MuseoModerno",
    "Noto Sans",
    "Noto Sans Display",
    "Noto Serif",
    "Noto Serif Display",
    "Noto Serif Tamil",
    "Overpass",
    "Pathway Extreme",
    "Petrona",
    "Piazzolla",
    "Poppins",
    "Prompt",
    "Public Sans",
    "Raleway",
    "Roboto Serif",
    "Rokkitt",
    "Saira",
    "Sofia Sans",
    "Sofia Sans Condensed",
    "Sofia Sans Extra Condensed",
    "Sofia Sans Semi Condensed",
    "Taviraj",
    "Texturina",
    "Tomorrow",
    "Tourney",
    "Trirong",
    "Urbanist",
    "Work Sans",
    "Ysabeau",
    "Asap Condensed",
    "Crimson Pro",
    "Glory",
    "JetBrains Mono",
    "K2D",
    "Literata",
    "Livvic",
    "Mulish",
    "Nunito",
    "Nunito Sans",
    "Sarabun",
    "Source Code Pro",
    "Source Sans 3",
    "Source Serif 4",
    "Alegreya Sans",
    "Alegreya Sans SC",
    "Figtree",
    "IBM Plex Mono",
    "IBM Plex Sans",
    "IBM Plex Sans Condensed",
    "IBM Plex Serif",
    "Josefin Sans",
    "Josefin Slab",
    "Kantumruy Pro",
    "Karla",
    "Newsreader",
    "Playfair",
    "Plus Jakarta Sans",
    "Red Hat Display",
    "Roboto Mono",
    "Rubik",
    "Spectral",
    "Spectral SC",
    "Alegreya",
    "Bai Jamjuree",
    "Besley",
    "Bodoni Moda",
    "Fahkwang",
    "Faustina",
    "KoHo",
    "Kodchasan",
    "Krub",
    "Kufam",
    "Mali",
    "Manuale",
    "Merriweather Sans",
    "Niramit",
    "Open Sans",
    "Playfair Display",
    "Roboto",
    "Schibsted Grotesk",
    "Shantell Sans",
    "Vollkorn",
    "Titillium Web",
    "Alegreya SC",
    "Andada Pro",
    "Chakra Petch",
    "Cormorant",
    "Cormorant Garamond",
    "Cormorant Infant",
    "EB Garamond",
    "Kulim Park",
    "Lato",
    "Mohave",
    "Proza Libre",
    "Radio Canada",
    "Rasa",
    "Red Hat Mono",
    "Red Hat Text",
    "Rosario",
    "Spline Sans Mono",
    "Wix Madefor Text",
    "Yrsa",
    "Zilla Slab",
    "Alexandria",
    "Big Shoulders Display",
    "Big Shoulders Inline Display",
    "Big Shoulders Inline Text",
    "Big Shoulders Stencil Display",
    "Big Shoulders Stencil Text",
    "Big Shoulders Text",
    "Catamaran",
    "Comme",
    "Commissioner",
    "Encode Sans",
    "Encode Sans Condensed",
    "Encode Sans Expanded",
    "Encode Sans SC",
    "Encode Sans Semi Condensed",
    "Encode Sans Semi Expanded",
    "Foldit",
    "Geologica",
    "Gluten",
    "Gothic A1",
    "Grenze Gotisch",
    "Hahmlet",
    "Heebo",
    "Hepta Slab",
    "Imbue",
    "Inter",
    "Kumbh Sans",
    "League Spartan",
    "Lexend",
    "Lexend Deca",
    "Lexend Exa",
    "Lexend Giga",
    "Lexend Mega",
    "Lexend Peta",
    "Lexend Tera",
    "Lexend Zetta",
    "M PLUS 1",
    "M PLUS 2",
    "Murecho",
    "Noto Kufi Arabic",
    "Noto Rashi Hebrew",
    "Noto Sans Arabic",
    "Noto Sans Armenian",
    "Noto Sans Bengali",
    "Noto Sans Canadian Aboriginal",
    "Noto Sans Cham",
    "Noto Sans Cherokee",
    "Noto Sans Devanagari",
    "Noto Sans Ethiopic",
    "Noto Sans Georgian",
    "Noto Sans Gujarati",
    "Noto Sans Gurmukhi",
    "Noto Sans Hebrew",
    "Noto Sans JP",
    "Noto Sans Kannada",
    "Noto Sans Khmer",
    "Noto Sans Lao",
    "Noto Sans Lao Looped",
    "Noto Sans Malayalam",
    "Noto Sans Meetei Mayek",
    "Noto Sans Mono",
    "Noto Sans Myanmar",
    "Noto Sans Oriya",
    "Noto Sans Sinhala",
    "Noto Sans Symbols",
    "Noto Sans Syriac",
    "Noto Sans Tamil",
    "Noto Sans Telugu",
    "Noto Sans Thaana",
    "Noto Sans Thai",
    "Noto Sans Thai Looped",
    "Noto Serif Armenian",
    "Noto Serif Bengali",
    "Noto Serif Devanagari",
    "Noto Serif Ethiopic",
    "Noto Serif Georgian",
    "Noto Serif Gujarati",
    "Noto Serif Gurmukhi",
    "Noto Serif Hebrew",
    "Noto Serif Kannada",
    "Noto Serif Khmer",
    "Noto Serif Lao",
    "Noto Serif Malayalam",
    "Noto Serif Myanmar",
    "Noto Serif Sinhala",
    "Noto Serif Telugu",
    "Noto Serif Thai",
    "Noto Serif Tibetan",
    "Outfit",
    "Roboto Slab",
    "Saira Condensed",
    "Saira Extra Condensed",
    "Saira Semi Condensed",
    "Smooch Sans",
    "Truculenta",
    "Vazirmatn",
    "Anek Bangla",
    "Anek Devanagari",
    "Anek Gujarati",
    "Anek Gurmukhi",
    "Anek Kannada",
    "Anek Latin",
    "Anek Malayalam",
    "Anek Odia",
    "Anek Tamil",
    "Anek Telugu",
    "Archivo Narrow",
    "Arimo",
    "Blinker",
    "Brygada 1918",
    "Cabin",
    "Cairo",
    "Cairo Play",
    "Cuprum",
    "Expletus Sans",
    "Familjen Grotesk",
    "Finlandica",
    "Gelasio",
    "Ibarra Real Nova",
    "Inconsolata",
    "Instrument Sans",
    "Libre Bodoni",
    "Lora",
    "Mada",
    "Martian Mono",
    "Merriweather",
    "Noto Serif HK",
    "Poltawski Nowy",
    "STIX Two Text",
    "Sansita",
    "Sora",
    "Trispace",
    "Ubuntu",
    "Unbounded",
    "Antonio",
    "Anuphan",
    "Arima",
    "Assistant",
    "Biryani",
    "Changa",
    "Darker Grotesque",
    "Dosis",
    "Frank Ruhl Libre",
    "Gemunu Libre",
    "IBM Plex Sans Arabic",
    "IBM Plex Sans Devanagari",
    "IBM Plex Sans Hebrew",
    "IBM Plex Sans JP",
    "IBM Plex Sans KR",
    "IBM Plex Sans Thai",
    "IBM Plex Sans Thai Looped",
    "Inknut Antiqua",
    "Lateef",
    "M PLUS 1 Code",
    "M PLUS 1p",
    "M PLUS Code Latin",
    "M PLUS Rounded 1c",
    "Manrope",
    "Martel",
    "Martel Sans",
    "Material Symbols Outlined",
    "Material Symbols Rounded",
    "Material Symbols Sharp",
    "Merienda",
    "Montagu Slab",
    "Mukta",
    "Mukta Mahee",
    "Mukta Malar",
    "Mukta Vaani",
    "Noto Serif JP",
    "Noto Serif KR",
    "Noto Serif SC",
    "Noto Serif TC",
    "Oxanium",
    "Palanquin",
    "Phudu",
    "Recursive",
    "Sansita Swashed",
    "Sono",
    "Stick No Bills",
    "Tajawal",
    "Aleo",
    "Athiti",
    "Averia Libre",
    "Averia Sans Libre",
    "Averia Serif Libre",
    "Bellota",
    "Bellota Text",
    "Cinzel",
    "Comic Neue",
    "Crimson Text",
    "DM Mono",
    "DM Sans",
    "Golos Text",
    "Inria Sans",
    "Inria Serif",
    "Maitree",
    "Maven Pro",
    "Mitr",
    "Neuton",
    "Nobile",
    "Noto Sans HK",
    "Noto Sans KR",
    "Noto Sans SC",
    "Noto Sans TC",
    "Orbitron",
    "Oswald",
    "Overlock",
    "Playfair Display SC",
    "Pridi",
    "Readex Pro",
    "Roboto Condensed",
    "Ruda",
    "Sarpanch",
    "Turret Road",
    "Yaldevi",
    "Yanone Kaffeesatz",
    "Yantramanav",
    "Abhaya Libre",
    "Akshar",
    "Atma",
    "Baloo 2",
    "Baloo Bhai 2",
    "Baloo Bhaijaan 2",
    "Baloo Bhaina 2",
    "Baloo Chettan 2",
    "Baloo Da 2",
    "Baloo Paaji 2",
    "Baloo Tamma 2",
    "Baloo Tammudu 2",
    "Baloo Thambi 2",
    "Battambang",
    "BioRhyme",
    "BioRhyme Expanded",
    "Chathura",
    "Comfortaa",
    "Cormorant SC",
    "Cormorant Unicase",
    "Cormorant Upright",
    "Eczar",
    "Fira Code",
    "Fredoka",
    "Halant",
    "Hanuman",
    "Hind",
    "Hind Guntur",
    "Hind Madurai",
    "Hind Siliguri",
    "Hind Vadodara",
    "Jura",
    "Karma",
    "Khand",
    "Khula",
    "Koh Santepheap",
    "Kreon",
    "Laila",
    "Lemonada",
    "Marhey",
    "Nokora",
    "Noto Emoji",
    "Noto Traditional Nushu",
    "Overpass Mono",
    "Podkova",
    "Pontano Sans",
    "Quicksand",
    "Rajdhani",
    "Red Rose",
    "Shippori Mincho",
    "Shippori Mincho B1",
    "Signika",
    "Signika Negative",
    "Solway",
    "Space Grotesk",
    "Spline Sans",
    "Suwannaphum",
    "Syne",
    "Teko",
    "Tillana",
    "Tsukimi Rounded",
    "Varta",
    "Wix Madefor Display",
    "Zen Kaku Gothic Antique",
    "Zen Kaku Gothic New",
    "Zen Maru Gothic",
    "Zen Old Mincho",
    "Alkatra",
    "Almarai",
    "Almendra",
    "Amaranth",
    "Amiri",
    "Andika",
    "Anonymous Pro",
    "Arsenal",
    "Arvo",
    "Atkinson Hyperlegible",
    "B612",
    "B612 Mono",
    "Balsamiq Sans",
    "Cabin Condensed",
    "Caladea",
    "Cambay",
    "Cantarell",
    "Carlito",
    "Caudex",
    "Caveat",
    "Charis SIL",
    "Courier Prime",
    "Cousine",
    "Dancing Script",
    "Domine",
    "DynaPuff",
    "Economica",
    "Edu NSW ACT Foundation",
    "Edu QLD Beginner",
    "Edu SA Beginner",
    "Edu TAS Beginner",
    "Edu VIC WA NT Beginner",
    "El Messiri",
    "Enriqueta",
    "Farro",
    "GFS Neohellenic",
    "Gentium Book Plus",
    "Gentium Plus",
    "Harmattan",
    "Istok Web",
    "Kaisei Tokumin",
    "Lobster Two",
    "Londrina Solid",
    "Markazi Text",
    "Marvel",
    "Mirza",
    "Noticia Text",
    "Noto Naskh Arabic",
    "Noto Nastaliq Urdu",
    "Noto Sans Adlam",
    "Noto Sans Adlam Unjoined",
    "Noto Sans Balinese",
    "Noto Sans Bamum",
    "Noto Sans Bassa Vah",
    "Noto Sans Hanifi Rohingya",
    "Noto Sans Javanese",
    "Noto Sans Kayah Li",
    "Noto Sans Lisu",
    "Noto Sans Medefaidrin",
    "Noto Sans Nag Mundari",
    "Noto Sans New Tai Lue",
    "Noto Sans Ol Chiki",
    "Noto Sans Sora Sompeng",
    "Noto Sans Sundanese",
    "Noto Sans Tai Tham",
    "Noto Sans Tangsa",
    "Noto Serif Khojki",
    "Noto Serif NP Hmong",
    "Noto Serif Oriya",
    "Noto Serif Toto",
    "Noto Serif Yezidi",
    "PT Sans",
    "PT Serif",
    "Palanquin Dark",
    "Philosopher",
    "Puritan",
    "Quantico",
    "Quattrocento Sans",
    "Rambla",
    "Reem Kufi",
    "Reem Kufi Fun",
    "Scada",
    "Scheherazade New",
    "Share",
    "Simonetta",
    "Space Mono",
    "Thasadith",
    "Tinos",
    "Ubuntu Mono",
    "Unna",
    "Vesper Libre",
    "Volkhov",
    "Vollkorn SC",
    "Amiko",
    "BenchNine",
    "Bona Nova",
    "Cardo",
    "Cinzel Decorative",
    "David Libre",
    "Dongle",
    "Fira Mono",
    "Gaegu",
    "Gayathri",
    "Gudea",
    "Gupter",
    "Judson",
    "Kaisei Decol",
    "Kaisei HarunoUmi",
    "Kaisei Opti",
    "Kalam",
    "Karantina",
    "Kiwi Maru",
    "Lekton",
    "Libre Baskerville",
    "Libre Caslon Text",
    "Life Savers",
    "Manjari",
    "Nanum Gothic",
    "Nanum Myeongjo",
    "Old Standard TT",
    "Oxygen",
    "Passion One",
    "Redacted Script",
    "Rowdies",
    "Sen",
    "Sulphur Point",
    "Sunflower",
    "Tienne",
    "Trochut",
    "ABeeZee",
    "Alef",
    "Allan",
    "Alumni Sans Collegiate One",
    "Alumni Sans Inline One",
    "Alumni Sans Pinstripe",
    "Amatic SC",
    "Amita",
    "Arapey",
    "Aref Ruqaa",
    "Aref Ruqaa Ink",
    "Arya",
    "Astloch",
    "Asul",
    "BIZ UDGothic",
    "BIZ UDMincho",
    "BIZ UDPGothic",
    "BIZ UDPMincho",
    "Baskervville",
    "Bevan",
    "Birthstone Bounce",
    "Brawler",
    "Buenard",
    "Cabin Sketch",
    "Castoro",
    "Changa One",
    "Charm",
    "Charmonman",
    "Chau Philomene One",
    "Cherry Swash",
    "Coda",
    "Codystar",
    "Content",
    "Corben",
    "Corinthia",
    "Coustard",
    "Crete Round",
    "DM Serif Display",
    "DM Serif Text",
    "Delius Unicase",
    "Elsie",
    "Elsie Swash Caps",
    "Fanwood Text",
    "Flamenco",
    "Fondamento",
    "Fragment Mono",
    "Fruktur",
    "Fuzzy Bubbles",
    "Geo",
    "Glegoo",
    "Goldman",
    "Gorditas",
    "Gowun Batang",
    "Gwendolyn",
    "IM Fell DW Pica",
    "IM Fell Double Pica",
    "IM Fell English",
    "IM Fell French Canon",
    "IM Fell Great Primer",
    "Inika",
    "Instrument Serif",
    "Jaldi",
    "Kadwa",
    "Kameron",
    "Klee One",
    "Linden Hill",
    "Lusitana",
    "Magra",
    "Mate",
    "Mina",
    "Miriam Libre",
    "Monda",
    "Montserrat Subrayada",
    "Mountains of Christmas",
    "Nanum Gothic Coding",
    "News Cycle",
    "Oleo Script",
    "Oleo Script Swash Caps",
    "Oregano",
    "PT Sans Caption",
    "PT Sans Narrow",
    "PT Serif Caption",
    "Padauk",
    "Play",
    "Poly",
    "Pragati Narrow",
    "Quattrocento",
    "Qwitcher Grypen",
    "Radley",
    "Ranga",
    "Ropa Sans",
    "Rosarivo",
    "Rufina",
    "Sahitya",
    "Sanchez",
    "Sarala",
    "Silkscreen",
    "Sintony",
    "Skranji",
    "Sniglet",
    "Sorts Mill Goudy",
    "Srisakdi",
    "Stardos Stencil",
    "Stoke",
    "Sumana",
    "Sura",
    "Syncopate",
    "Tai Heritage Pro",
    "Tangerine",
    "The Nautigal",
    "Tiro Bangla",
    "Tiro Devanagari Hindi",
    "Tiro Devanagari Marathi",
    "Tiro Devanagari Sanskrit",
    "Tiro Gurmukhi",
    "Tiro Kannada",
    "Tiro Tamil",
    "Tiro Telugu",
    "Unkempt",
    "WindSong",
    "Xanh Mono",
    "Zen Loop",
    "Zilla Slab Highlight",
    "Abel",
    "Aboreto",
    "Abril Fatface",
    "Abyssinica SIL",
    "Aclonica",
    "Acme",
    "Actor",
    "Adamina",
    "Aguafina Script",
    "Akaya Kanadaka",
    "Akaya Telivigala",
    "Akronim",
    "Aladin",
    "Alata",
    "Alatsi",
    "Aldrich",
    "Alex Brush",
    "Alfa Slab One",
    "Alice",
    "Alike",
    "Alike Angular",
    "Alkalami",
    "Allerta",
    "Allerta Stencil",
    "Allison",
    "Allura",
    "Almendra Display",
    "Almendra SC",
    "Amarante",
    "Amethysta",
    "Amiri Quran",
    "Anaheim",
    "Angkor",
    "Annie Use Your Telescope",
    "Antic",
    "Antic Didone",
    "Antic Slab",
    "Anton",
    "Aoboshi One",
    "Arbutus",
    "Arbutus Slab",
    "Architects Daughter",
    "Archivo Black",
    "Are You Serious",
    "Arizonia",
    "Armata",
    "Artifika",
    "Asar",
    "Asset",
    "Atomic Age",
    "Aubrey",
    "Audiowide",
    "Autour One",
    "Average",
    "Average Sans",
    "Averia Gruesa Libre",
    "Babylonica",
    "Bad Script",
    "Bagel Fat One",
    "Bahiana",
    "Bahianita",
    "Bakbak One",
    "Ballet",
    "Balthazar",
    "Bangers",
    "Barriecito",
    "Barrio",
    "Basic",
    "Baumans",
    "Bayon",
    "Beau Rivage",
    "Bebas Neue",
    "Belgrano",
    "Bellefair",
    "Belleza",
    "Benne",
    "Bentham",
    "Berkshire Swash",
    "Beth Ellen",
    "BhuTuka Expanded One",
    "Bigelow Rules",
    "Bigshot One",
    "Bilbo",
    "Bilbo Swash Caps",
    "Birthstone",
    "Black And White Picture",
    "Black Han Sans",
    "Black Ops One",
    "Blaka",
    "Blaka Hollow",
    "Blaka Ink",
    "Bokor",
    "Bonbon",
    "Bonheur Royale",
    "Boogaloo",
    "Bowlby One",
    "Bowlby One SC",
    "Braah One",
    "Bree Serif",
    "Bruno Ace",
    "Bruno Ace SC",
    "Bubblegum Sans",
    "Bubbler One",
    "Buda",
    "Bungee",
    "Bungee Hairline",
    "Bungee Inline",
    "Bungee Outline",
    "Bungee Shade",
    "Bungee Spice",
    "Butcherman",
    "Butterfly Kids",
    "Caesar Dressing",
    "Cagliostro",
    "Calistoga",
    "Calligraffitti",
    "Cambo",
    "Candal",
    "Cantata One",
    "Cantora One",
    "Capriola",
    "Caramel",
    "Carattere",
    "Carme",
    "Carrois Gothic",
    "Carrois Gothic SC",
    "Carter One",
    "Castoro Titling",
    "Caveat Brush",
    "Cedarville Cursive",
    "Ceviche One",
    "Chango",
    "Chela One",
    "Chelsea Market",
    "Chenla",
    "Cherish",
    "Cherry Bomb One",
    "Cherry Cream Soda",
    "Chewy",
    "Chicle",
    "Chilanka",
    "Chokokutai",
    "Chonburi",
    "Clicker Script",
    "Climate Crisis",
    "Coiny",
    "Combo",
    "Comforter",
    "Comforter Brush",
    "Coming Soon",
    "Concert One",
    "Condiment",
    "Contrail One",
    "Convergence",
    "Cookie",
    "Copse",
    "Courgette",
    "Covered By Your Grace",
    "Crafty Girls",
    "Creepster",
    "Croissant One",
    "Crushed",
    "Cute Font",
    "Cutive",
    "Cutive Mono",
    "Damion",
    "Dangrek",
    "Darumadrop One",
    "Dawning of a New Day",
    "Days One",
    "Dekko",
    "Dela Gothic One",
    "Delicious Handrawn",
    "Delius",
    "Delius Swash Caps",
    "Della Respira",
    "Denk One",
    "Devonshire",
    "Dhurjati",
    "Didact Gothic",
    "Diphylleia",
    "Diplomata",
    "Diplomata SC",
    "Do Hyeon",
    "Dokdo",
    "Donegal One",
    "Doppio One",
    "Dorsa",
    "DotGothic16",
    "Dr Sugiyama",
    "Duru Sans",
    "Dynalight",
    "Eagle Lake",
    "East Sea Dokdo",
    "Eater",
    "Electrolize",
    "Emblema One",
    "Emilys Candy",
    "Engagement",
    "Englebert",
    "Ephesis",
    "Erica One",
    "Esteban",
    "Estonia",
    "Euphoria Script",
    "Ewert",
    "Explora",
    "Farsan",
    "Fascinate",
    "Fascinate Inline",
    "Faster One",
    "Fasthand",
    "Fauna One",
    "Federant",
    "Federo",
    "Felipa",
    "Fenix",
    "Festive",
    "Finger Paint",
    "Fjalla One",
    "Fjord One",
    "Flavors",
    "Fleur De Leah",
    "Flow Block",
    "Flow Circular",
    "Flow Rounded",
    "Fontdiner Swanky",
    "Forum",
    "Francois One",
    "Freckle Face",
    "Fredericka the Great",
    "Freehand",
    "Fresca",
    "Frijole",
    "Fugaz One",
    "Fuggles",
    "GFS Didot",
    "Gabriela",
    "Gafata",
    "Gajraj One",
    "Galada",
    "Galdeano",
    "Galindo",
    "Gamja Flower",
    "Gasoek One",
    "Geostar",
    "Geostar Fill",
    "Germania One",
    "Gideon Roman",
    "Gidugu",
    "Gilda Display",
    "Girassol",
    "Give You Glory",
    "Glass Antiqua",
    "Gloock",
    "Gloria Hallelujah",
    "Goblin One",
    "Gochi Hand",
    "Gotu",
    "Goudy Bookletter 1911",
    "Gowun Dodum",
    "Graduate",
    "Grand Hotel",
    "Grandiflora One",
    "Grape Nuts",
    "Gravitas One",
    "Great Vibes",
    "Grechen Fuemen",
    "Grey Qo",
    "Griffy",
    "Gruppo",
    "Gugi",
    "Gulzar",
    "Gurajada",
    "Habibi",
    "Hachi Maru Pop",
    "Hammersmith One",
    "Hanalei",
    "Hanalei Fill",
    "Handlee",
    "Happy Monkey",
    "Headland One",
    "Henny Penny",
    "Herr Von Muellerhoff",
    "Hi Melody",
    "Hina Mincho",
    "Holtwood One SC",
    "Homemade Apple",
    "Homenaje",
    "Hubballi",
    "Hurricane",
    "IM Fell DW Pica SC",
    "IM Fell Double Pica SC",
    "IM Fell English SC",
    "IM Fell French Canon SC",
    "IM Fell Great Primer SC",
    "Iceberg",
    "Iceland",
    "Imperial Script",
    "Imprima",
    "Inder",
    "Indie Flower",
    "Ingrid Darling",
    "Inspiration",
    "Irish Grover",
    "Island Moments",
    "Italiana",
    "Italianno",
    "Itim",
    "Jacques Francois",
    "Jacques Francois Shadow",
    "Jim Nightshade",
    "Joan",
    "Jockey One",
    "Jolly Lodger",
    "Jomhuria",
    "Jomolhari",
    "Joti One",
    "Jua",
    "Julee",
    "Julius Sans One",
    "Junge",
    "Just Another Hand",
    "Just Me Again Down Here",
    "Katibeh",
    "Kaushan Script",
    "Kavivanar",
    "Kavoon",
    "Kdam Thmor Pro",
    "Keania One",
    "Kelly Slab",
    "Kenia",
    "Khmer",
    "Kings",
    "Kirang Haerang",
    "Kite One",
    "Knewave",
    "Kolker Brush",
    "Konkhmer Sleokchher",
    "Kosugi",
    "Kosugi Maru",
    "Kotta One",
    "Koulen",
    "Kranky",
    "Kristi",
    "Krona One",
    "Kumar One",
    "Kumar One Outline",
    "Kurale",
    "La Belle Aurore",
    "Lacquer",
    "Lakki Reddy",
    "Lalezar",
    "Lancelot",
    "Langar",
    "Lavishly Yours",
    "League Gothic",
    "League Script",
    "Leckerli One",
    "Ledger",
    "Lemon",
    "Libre Barcode 128",
    "Libre Barcode 128 Text",
    "Libre Barcode 39",
    "Libre Barcode 39 Extended",
    "Libre Barcode 39 Extended Text",
    "Libre Barcode 39 Text",
    "Libre Barcode EAN13 Text",
    "Libre Caslon Display",
    "Licorice",
    "Lilita One",
    "Lily Script One",
    "Limelight",
    "Liu Jian Mao Cao",
    "Lobster",
    "Londrina Outline",
    "Londrina Shadow",
    "Londrina Sketch",
    "Long Cang",
    "Love Light",
    "Love Ya Like A Sister",
    "Loved by the King",
    "Lovers Quarrel",
    "Luckiest Guy",
    "Lustria",
    "Luxurious Roman",
    "Luxurious Script",
    "Ma Shan Zheng",
    "Macondo",
    "Macondo Swash Caps",
    "Maiden Orange",
    "Major Mono Display",
    "Mako",
    "Mallanna",
    "Mandali",
    "Mansalva",
    "Marcellus",
    "Marcellus SC",
    "Marck Script",
    "Margarine",
    "Marko One",
    "Marmelad",
    "Mate SC",
    "Material Icons",
    "Material Icons Outlined",
    "Material Icons Round",
    "Material Icons Sharp",
    "Material Icons Two Tone",
    "McLaren",
    "Mea Culpa",
    "Meddon",
    "MedievalSharp",
    "Medula One",
    "Meera Inimai",
    "Megrim",
    "Meie Script",
    "Meow Script",
    "Metal",
    "Metal Mania",
    "Metamorphous",
    "Metrophobic",
    "Michroma",
    "Milonga",
    "Miltonian",
    "Miltonian Tattoo",
    "Mingzat",
    "Miniver",
    "Miss Fajardose",
    "Mochiy Pop One",
    "Mochiy Pop P One",
    "Modak",
    "Modern Antiqua",
    "Mogra",
    "Moirai One",
    "Molengo",
    "Molle",
    "Monofett",
    "Monomaniac One",
    "Monoton",
    "Monsieur La Doulaise",
    "Montaga",
    "MonteCarlo",
    "Montez",
    "Moo Lah Lah",
    "Moon Dance",
    "Moul",
    "Moulpali",
    "Mouse Memoirs",
    "Mr Bedfort",
    "Mr Dafoe",
    "Mr De Haviland",
    "Mrs Saint Delafield",
    "Mrs Sheppards",
    "Ms Madi",
    "My Soul",
    "Mynerve",
    "Mystery Quest",
    "NTR",
    "Nabla",
    "Nanum Brush Script",
    "Nanum Pen Script",
    "Neonderthaw",
    "Nerko One",
    "Neucha",
    "New Rocker",
    "New Tegomin",
    "Niconne",
    "Nixie One",
    "Norican",
    "Nosifer",
    "Notable",
    "Nothing You Could Do",
    "Noto Color Emoji",
    "Noto Music",
    "Noto Sans Anatolian Hieroglyphs",
    "Noto Sans Avestan",
    "Noto Sans Batak",
    "Noto Sans Bhaiksuki",
    "Noto Sans Brahmi",
    "Noto Sans Buginese",
    "Noto Sans Buhid",
    "Noto Sans Carian",
    "Noto Sans Caucasian Albanian",
    "Noto Sans Chakma",
    "Noto Sans Chorasmian",
    "Noto Sans Coptic",
    "Noto Sans Cuneiform",
    "Noto Sans Cypriot",
    "Noto Sans Deseret",
    "Noto Sans Duployan",
    "Noto Sans Egyptian Hieroglyphs",
    "Noto Sans Elbasan",
    "Noto Sans Elymaic",
    "Noto Sans Glagolitic",
    "Noto Sans Gothic",
    "Noto Sans Grantha",
    "Noto Sans Gunjala Gondi",
    "Noto Sans Hanunoo",
    "Noto Sans Hatran",
    "Noto Sans Imperial Aramaic",
    "Noto Sans Indic Siyaq Numbers",
    "Noto Sans Inscriptional Pahlavi",
    "Noto Sans Inscriptional Parthian",
    "Noto Sans Kaithi",
    "Noto Sans Kharoshthi",
    "Noto Sans Khojki",
    "Noto Sans Khudawadi",
    "Noto Sans Lepcha",
    "Noto Sans Limbu",
    "Noto Sans Linear A",
    "Noto Sans Linear B",
    "Noto Sans Lycian",
    "Noto Sans Lydian",
    "Noto Sans Mahajani",
    "Noto Sans Mandaic",
    "Noto Sans Manichaean",
    "Noto Sans Marchen",
    "Noto Sans Masaram Gondi",
    "Noto Sans Math",
    "Noto Sans Mayan Numerals",
    "Noto Sans Mende Kikakui",
    "Noto Sans Meroitic",
    "Noto Sans Miao",
    "Noto Sans Modi",
    "Noto Sans Mongolian",
    "Noto Sans Mro",
    "Noto Sans Multani",
    "Noto Sans NKo",
    "Noto Sans Nabataean",
    "Noto Sans Nandinagari",
    "Noto Sans Newa",
    "Noto Sans Nushu",
    "Noto Sans Ogham",
    "Noto Sans Old Hungarian",
    "Noto Sans Old Italic",
    "Noto Sans Old North Arabian",
    "Noto Sans Old Permic",
    "Noto Sans Old Persian",
    "Noto Sans Old Sogdian",
    "Noto Sans Old South Arabian",
    "Noto Sans Old Turkic",
    "Noto Sans Osage",
    "Noto Sans Osmanya",
    "Noto Sans Pahawh Hmong",
    "Noto Sans Palmyrene",
    "Noto Sans Pau Cin Hau",
    "Noto Sans Phags Pa",
    "Noto Sans Phoenician",
    "Noto Sans Psalter Pahlavi",
    "Noto Sans Rejang",
    "Noto Sans Runic",
    "Noto Sans Samaritan",
    "Noto Sans Saurashtra",
    "Noto Sans Sharada",
    "Noto Sans Shavian",
    "Noto Sans Siddham",
    "Noto Sans SignWriting",
    "Noto Sans Sogdian",
    "Noto Sans Soyombo",
    "Noto Sans Syloti Nagri",
    "Noto Sans Symbols 2",
    "Noto Sans Tagalog",
    "Noto Sans Tagbanwa",
    "Noto Sans Tai Le",
    "Noto Sans Tai Viet",
    "Noto Sans Takri",
    "Noto Sans Tamil Supplement",
    "Noto Sans Tifinagh",
    "Noto Sans Tirhuta",
    "Noto Sans Ugaritic",
    "Noto Sans Vai",
    "Noto Sans Wancho",
    "Noto Sans Warang Citi",
    "Noto Sans Yi",
    "Noto Sans Zanabazar Square",
    "Noto Serif Ahom",
    "Noto Serif Balinese",
    "Noto Serif Dogra",
    "Noto Serif Grantha",
    "Noto Serif Tangut",
    "Nova Cut",
    "Nova Flat",
    "Nova Mono",
    "Nova Oval",
    "Nova Round",
    "Nova Script",
    "Nova Slim",
    "Nova Square",
    "Numans",
    "Nuosu SIL",
    "Odibee Sans",
    "Odor Mean Chey",
    "Offside",
    "Oi",
    "Oldenburg",
    "Ole",
    "Oooh Baby",
    "Oranienbaum",
    "Orbit",
    "Orelega One",
    "Orienta",
    "Original Surfer",
    "Over the Rainbow",
    "Overlock SC",
    "Ovo",
    "Oxygen Mono",
    "PT Mono",
    "Pacifico",
    "Padyakke Expanded One",
    "Palette Mosaic",
    "Pangolin",
    "Paprika",
    "Parisienne",
    "Passero One",
    "Passions Conflict",
    "Pathway Gothic One",
    "Patrick Hand",
    "Patrick Hand SC",
    "Pattaya",
    "Patua One",
    "Pavanam",
    "Paytone One",
    "Peddana",
    "Peralta",
    "Permanent Marker",
    "Petemoss",
    "Petit Formal Script",
    "Piedra",
    "Pinyon Script",
    "Pirata One",
    "Plaster",
    "Playball",
    "Poiret One",
    "Poller One",
    "Pompiere",
    "Poor Story",
    "Port Lligat Sans",
    "Port Lligat Slab",
    "Potta One",
    "Praise",
    "Prata",
    "Preahvihear",
    "Press Start 2P",
    "Princess Sofia",
    "Prociono",
    "Prosto One",
    "Puppies Play",
    "Purple Purse",
    "Qahiri",
    "Quando",
    "Questrial",
    "Quintessential",
    "Qwigley",
    "Racing Sans One",
    "Rakkas",
    "Raleway Dots",
    "Ramabhadra",
    "Ramaraja",
    "Rammetto One",
    "Rampart One",
    "Ranchers",
    "Rancho",
    "Rationale",
    "Ravi Prakash",
    "Redacted",
    "Redressed",
    "Reem Kufi Ink",
    "Reenie Beanie",
    "Reggae One",
    "Revalia",
    "Rhodium Libre",
    "Ribeye",
    "Ribeye Marrow",
    "Righteous",
    "Risque",
    "Road Rage",
    "Roboto Flex",
    "Rochester",
    "Rock 3D",
    "Rock Salt",
    "RocknRoll One",
    "Romanesco",
    "Rouge Script",
    "Rozha One",
    "Rubik 80s Fade",
    "Rubik Beastly",
    "Rubik Bubbles",
    "Rubik Burned",
    "Rubik Dirt",
    "Rubik Distressed",
    "Rubik Gemstones",
    "Rubik Glitch",
    "Rubik Iso",
    "Rubik Marker Hatch",
    "Rubik Maze",
    "Rubik Microbe",
    "Rubik Mono One",
    "Rubik Moonrocks",
    "Rubik Pixels",
    "Rubik Puddles",
    "Rubik Spray Paint",
    "Rubik Storm",
    "Rubik Vinyl",
    "Rubik Wet Paint",
    "Ruge Boogie",
    "Ruluko",
    "Rum Raisin",
    "Ruslan Display",
    "Russo One",
    "Ruthie",
    "Rye",
    "Sacramento",
    "Sail",
    "Saira Stencil One",
    "Salsa",
    "Sancreek",
    "Sarina",
    "Sassy Frass",
    "Satisfy",
    "Sawarabi Gothic",
    "Sawarabi Mincho",
    "Schoolbell",
    "Scope One",
    "Seaweed Script",
    "Secular One",
    "Sedgwick Ave",
    "Sedgwick Ave Display",
    "Send Flowers",
    "Sevillana",
    "Seymour One",
    "Shadows Into Light",
    "Shadows Into Light Two",
    "Shalimar",
    "Shanti",
    "Share Tech",
    "Share Tech Mono",
    "Shippori Antique",
    "Shippori Antique B1",
    "Shizuru",
    "Shojumaru",
    "Short Stack",
    "Shrikhand",
    "Siemreap",
    "Sigmar",
    "Sigmar One",
    "Single Day",
    "Sirin Stencil",
    "Six Caps",
    "Slabo 13px",
    "Slabo 27px",
    "Slackey",
    "Slackside One",
    "Smokum",
    "Smooch",
    "Smythe",
    "Snippet",
    "Snowburst One",
    "Sofadi One",
    "Sofia",
    "Solitreo",
    "Song Myung",
    "Sonsie One",
    "Special Elite",
    "Spicy Rice",
    "Spinnaker",
    "Spirax",
    "Splash",
    "Squada One",
    "Square Peg",
    "Sree Krushnadevaraya",
    "Sriracha",
    "Staatliches",
    "Stalemate",
    "Stalinist One",
    "Stick",
    "Stint Ultra Condensed",
    "Stint Ultra Expanded",
    "Strait",
    "Style Script",
    "Stylish",
    "Sue Ellen Francisco",
    "Suez One",
    "Sunshiney",
    "Supermercado One",
    "Suranna",
    "Suravaram",
    "Swanky and Moo Moo",
    "Syne Mono",
    "Syne Tactile",
    "Tapestry",
    "Taprom",
    "Tauri",
    "Telex",
    "Tenali Ramakrishna",
    "Tenor Sans",
    "Text Me One",
    "The Girl Next Door",
    "Tilt Neon",
    "Tilt Prism",
    "Tilt Warp",
    "Timmana",
    "Titan One",
    "Trade Winds",
    "Train One",
    "Trocchi",
    "Trykker",
    "Tulpen One",
    "Twinkle Star",
    "Ubuntu Condensed",
    "Uchen",
    "Ultra",
    "Uncial Antiqua",
    "Underdog",
    "Unica One",
    "UnifrakturCook",
    "UnifrakturMaguntia",
    "Unlock",
    "Updock",
    "VT323",
    "Vampiro One",
    "Varela",
    "Varela Round",
    "Vast Shadow",
    "Viaoda Libre",
    "Vibes",
    "Vibur",
    "Vidaloka",
    "Viga",
    "Vina Sans",
    "Voces",
    "Voltaire",
    "Vujahday Script",
    "Waiting for the Sunrise",
    "Wallpoet",
    "Walter Turncoat",
    "Warnes",
    "Water Brush",
    "Waterfall",
    "Wellfleet",
    "Wendy One",
    "Whisper",
    "Wire One",
    "Yatra One",
    "Yellowtail",
    "Yeon Sung",
    "Yeseva One",
    "Yesteryear",
    "Yomogi",
    "Yuji Boku",
    "Yuji Hentaigana Akari",
    "Yuji Hentaigana Akebono",
    "Yuji Mai",
    "Yuji Syuku",
    "Yusei Magic",
    "ZCOOL KuaiLe",
    "ZCOOL QingKe HuangYou",
    "ZCOOL XiaoWei",
    "Zen Antique",
    "Zen Antique Soft",
    "Zen Dots",
    "Zen Kurenaido",
    "Zen Tokyo Zoo",
    "Zeyada",
    "Zhi Mang Xing",
  ],

  brandProfile: {},
  businessSuites: {},
  layoutSelected: {},
  suites: [],
  ailimit: "",
  colorCodeSuggest: "",
};
